import React from "react";

const BASE = process.env.PUBLIC_URL || "";
export const LOGO_SRC = `${BASE}/brand/caterctrl-logo.svg`;
export const HAT_SRC = `${BASE}/brand/caterctrl-hat.png`;

// Authoritative CaterCTRL artwork (docs/brand). Never redraw, recolour or stretch it.
export function Logo({ size = "md", compact = false, className = "" }) {
  if (compact) return <BrandHat size={size} className={className} />;
  const h = /(^|\s)h-/.test(className) ? "" : size === "lg" ? "h-20" : size === "sm" ? "h-9" : "h-14";
  return (
    <img src={LOGO_SRC} alt="CaterCTRL" data-testid="app-logo"
      className={`${h} w-auto max-w-full object-contain select-none ${className}`} draggable={false} />
  );
}

export function BrandHat({ size = "md", className = "" }) {
  const d = size === "lg" ? "h-11 w-11" : size === "sm" ? "h-7 w-7" : "h-9 w-9";
  return (
    <img src={HAT_SRC} alt="CaterCTRL" data-testid="app-logo-compact"
      className={`${d} rounded-lg object-cover shrink-0 select-none ${className}`} draggable={false} />
  );
}
